import { useSelector } from "react-redux";
import { RootState } from "../store/store";
import { Facility } from "../types/facility.definition";
import { Manager } from "../types/manager.definition";
import { Secretary } from "../types/secretary.definition";
import useManager from "./useManager";
import useSecretary from "./useSecretary";

type FacilityUser = (Manager | Secretary) & {
  healthcareFacility: Facility;
};

/**
 * Hook that returns the current user (manager or secretary) with their facility
 * This allows pages to work with both roles seamlessly
 */
export function useFacilityUser(): FacilityUser {
  const { session } = useSelector((state: RootState) => state.session);
  const manager = useManager();
  const secretary = useSecretary();

  const userRole = session?.user?.roleName?.toLowerCase();

  if (userRole === "secretary") {
    return secretary as FacilityUser;
  }

  return manager as FacilityUser;
}

export default useFacilityUser;
